import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'; // Corrected import
import { ApiService } from './API/api.service';
import { CompanyService } from './Company/company.service';
import { UserService } from './User/user.service';

@NgModule({
  declarations: [],
  imports: [CommonModule, HttpClientModule], // Added HttpClientModule here
  exports: [HttpClientModule], // Exporting HttpClientModule
  providers: [
    ApiService,
    CompanyService,
    UserService,
    provideHttpClient(withInterceptorsFromDi()) // Only provide it once
  ]
})
export class ServicesModule {}
